import { render } from "./ModalAddStages.vue?vue&type=template&id=789c3a1e&scoped=true"
import script from "./ModalAddStages.vue?vue&type=script&lang=js"
export * from "./ModalAddStages.vue?vue&type=script&lang=js"

import "./ModalAddStages.vue?vue&type=style&index=0&id=789c3a1e&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-789c3a1e"]])

export default __exports__